import { Controller } from "@hotwired/stimulus";

export class RecipientsFilterToggleController extends Controller {
  static targets = [
    "select",
    "reportSelect",
    "trackFilterSelect",
    "trackGroup",
    "ticketTypesGroup"
  ];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasSelectTarget) return;

    const value = this.selectTarget.value;
    const usingReport = value === "report";

    if (this.hasReportSelectTarget) {
      this.toggleControl(this.reportSelectTarget, usingReport);
      this.reportSelectTarget.required = usingReport;
    }

    if (this.hasTrackFilterSelectTarget) {
      this.toggleControl(this.trackFilterSelectTarget, !usingReport);
    }
    this.trackGroupTargets.forEach((target) => this.toggleControl(target, !usingReport));
    this.ticketTypesGroupTargets.forEach((target) => this.toggleControl(target, !usingReport));

    if (usingReport) {
      this.resetTrackSelections();
    } else {
      this.clearReportSelection();
      this.ensureTrackVisibility();
    }
  }

  toggleControl(target, show) {
    if (!target) return;

    const wrapper = this.controlWrapper(target);
    if (!wrapper) return;

    if (show) {
      wrapper.hidden = false;
      wrapper.style.removeProperty("display");
    } else {
      wrapper.hidden = true;
      wrapper.style.display = "none";
    }
  }

  controlWrapper(element) {
    if (!element) return null;

    return (
      element.closest(".FormControl") ||
      element.closest(".FormControl-check-group-wrap") ||
      element.parentElement
    );
  }

  resetTrackSelections() {
    if (this.hasTrackFilterSelectTarget && this.trackFilterSelectTarget.value !== "none") {
      this.trackFilterSelectTarget.value = "none";
      this.trackFilterSelectTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }

    this.clearCheckboxes(this.trackGroupTargets);
    this.clearCheckboxes(this.ticketTypesGroupTargets);
  }

  ensureTrackVisibility() {
    if (this.hasTrackFilterSelectTarget) {
      this.trackFilterSelectTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  clearReportSelection() {
    if (this.hasReportSelectTarget && this.reportSelectTarget.value !== "") {
      this.reportSelectTarget.value = "";
    }
  }

  clearCheckboxes(targets) {
    targets.forEach((target) => {
      const inputs = target.querySelectorAll("input[type='checkbox']");
      inputs.forEach((input) => {
        input.checked = false;
      });
    });
  }
}

